import styled from "styled-components";
import { WhiteLogoIcon } from "./CommonUI/Icon/WhiteLogoIcon";
import { UIDropdownMenu } from "./CommonUI/BuildlingBlocks/UIDropdownMenu";
import { UIStyleConstants } from "./rule-engine-core/Common/UIStyleConstants";

export class MenuColumn {
    name: string;
    categories: (MenuCategory | MenuItem)[];
    color: string;
    icon: () => JSX.Element;
    description?: string;

    constructor(
        name: string,
        categories: (MenuCategory | MenuItem)[] = [],
        color: string,
        icon: () => JSX.Element,
        description?: string,
    ) {
        this.name = name;
        this.categories = categories;
        this.color = color;
        this.icon = icon;
        this.description = description;
    }
}

export class MenuCategory {
    name: string;
    items: MenuItem[];
    description?: string;

    constructor(name: string, items: MenuItem[] = [], description?: string) {
        this.name = name;
        this.items = items;
        this.description = description;
    }
}

export class MenuItem {
    name: string;
    ui: () => JSX.Element;
    img: () => JSX.Element;

    constructor(name: string, ui: () => JSX.Element, img: () => JSX.Element) {
        this.name = name;
        this.ui = ui;
        this.img = img;
    }
}

export const changePage = (category: string, page?: string): void => {
    let querys = [`category=${category}`];
    if (page) {
        querys.push(`page=${page}`);
    }
    window.location.assign(`?${querys.join("&")}`);
};

export const MenuItemRender = ({ item, category }: { item: MenuItem; category: MenuCategory | MenuColumn }) => {
    return (
        <StyledNavItem
            onClick={!!item.ui ? () => changePage(category.name, item.name) : undefined}
            key={item.name}
        >
            {item.name}
        </StyledNavItem>
    );
};

export const MenuCategoryItem = ({ item }: { item: MenuCategory }) => {
    return (
        <UIDropdownMenu
            title={item.name}
            items={item.items.map((mItem) => ({
                renderUI: () => (
                    <MenuItemRender
                        item={mItem}
                        category={item}
                    />
                ),
            }))}
            key={item.name}
            ahchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "left",
            }}
            direction="right"
        />
    );
};

export const TestAppMenu = ({ items }: { items: MenuColumn[] }) => {
    let updatedItems: { [key: string]: MenuColumn } = {};

    items.forEach((item) => {
        if (!updatedItems[item.name]) {
            updatedItems[item.name] = new MenuColumn(
                item.name,
                [...item.categories],
                item.color,
                item.icon,
                item.description,
            );
        } else {
            for (let cat of item.categories) {
                if (!updatedItems[item.name].categories.includes(cat)) {
                    updatedItems[item.name].categories.push(cat);
                }
            }
        }
    });

    return (
        <NavigationWrapper>
            <Logo
                onClick={() => {
                    window.location.href = "/";
                }}
            >
                <WhiteLogoIcon />
            </Logo>

            {Object.values(updatedItems).map((menuItem) => {
                return (
                    <UIDropdownMenu
                        title={menuItem.name}
                        items={menuItem.categories.map((item) => ({
                            renderUI: () =>
                                item instanceof MenuCategory ? (
                                    <MenuCategoryItem item={item} />
                                ) : (
                                    <MenuItemRender
                                        item={item}
                                        category={menuItem}
                                    />
                                ),
                        }))}
                        key={menuItem.name}
                    />
                );
            })}

            <ContactUsButton href="mailto:carl@appglue.com">Contact Us</ContactUsButton>
        </NavigationWrapper>
    );
};

const NavigationWrapper = styled.div`
    display: flex;
    background: ${UIStyleConstants.BLUE_COLOR};
    padding: 4px 16px;
    align-items: center;
`;

const Logo = styled.div`
    margin-right: 12px;

    cursor: pointer;
`;

const ContactUsButton = styled.a`
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: center;

    text-decoration: none;

    padding: 7px 13px;

    border: 1px solid ${UIStyleConstants.WHITE_COLOR};
    box-sizing: border-box;
    border-radius: 4px;

    margin-left: auto;
    color: ${UIStyleConstants.WHITE_COLOR};

    display: flex;
    align-items: center;
    justify-content: center;
`;

const StyledNavItem = styled.div<{ selected?: boolean }>`
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0px;
    text-align: left;

    padding: 8px;

    cursor: pointer;

    color: ${(props) => (props.selected ? UIStyleConstants.BLUE_COLOR : UIStyleConstants.BLUE_COLOR)};
`;
